import React, { useState, useEffect } from 'react';
import './TabTeamPolicies.less';
import RenderingImage from '../../common/RenderingImage';

const DEFAULT_ROLES = {
  curator: 'Куратор',
  employer: 'Заказчик',
  head: 'Руководитель',
  admin: 'Администратор',
  coordinator: 'Координатор',
  participant: 'Участник',
  participantAdmin: 'Участник с правами администратора',
};

const sorter = (aRole, bRole, rolesDict) => {
  const aRoleFound = rolesDict[aRole];
  const bRoleFound = rolesDict[bRole];

  const aOrder = aRoleFound ? aRoleFound.order : 100;
  const bOrder = bRoleFound ? bRoleFound.order : 100;

  return aOrder - bOrder;
};

export default function TabTeamPolicies(props) {
  const [trends, setTrends] = useState([]);
  useEffect(() => {
    createTrendsList();
  }, []);

  const createTrendsList = () => {
    const result = [];
    const items = props.data.users.filter((user) => user.area !== null).map((user) => user.area.name);
    for (const item of items) {
      if (!result.includes(item)) {
        result.push(item);
      }
    }
    setTrends(result);
  };

  const displayRoles = props.roles || DEFAULT_ROLES;
  const orderedRoles = Object.entries(displayRoles).reduce((acc, [key, value], i) => ({ ...acc, [key]: { label: value, order: i } }));
  const users = props.data.users.sort((a, b) => sorter(a.role, b.role, orderedRoles));

  return (
    <div className="tab-trends">
      <div className="tab-team">
        {users.filter((user) => !user.area).map((user, i) => (
          <div key={i} className="user-card">
            <div className="img-wrapper">{user.avatars && user.avatars.full && <RenderingImage url={user.avatars.full} />}</div>
            <div className="text-content-wrapper">
              <p className="team-post head-policy"><b>{displayRoles[user.role] || user.role}</b></p>
              <p className="attachment">центра Цифровой Трансформации</p>
              <p>{`${user.lastName} ${user.firstName} ${user.middleName}`}</p>
              <p className="person-post">{`${user.post}`}</p>
            </div>
          </div>
        ))}
      </div>
      {trends.map((trend, index) => (
        <div key={index}>
          <h4>
            Направление «
            {trend}
            »
          </h4>
          <div className="tab-team">
            {users.filter((user) => user.area && user.area.name === trend).map((user, i) => (
              <div key={i} className="user-card">
                <div className="img-wrapper">{user.avatars && user.avatars.full && <RenderingImage url={user.avatars.full} />}</div>
                <div className="text-content-wrapper">
                  <p className="team-post"><b>{displayRoles[user.role] || user.role}</b></p>
                  <p>{`${user.lastName} ${user.firstName} ${user.middleName}`}</p>
                  <p className="person-post">{`${user.post}`}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
